import { Stack } from "@mui/material";
import React from "react";
import PerformanceMetricsMobile from "./PerformanceMetricsMobile";
import PerformanceMetrics from "./PerformanceMetrics";
import grid from "./Images/Grid103.webp";
const MainPerformanceMetrics = () => {
  return (
    <Stack>
      <Stack
        sx={{
          display: {
            xl: "flex",
            lg: "flex",
            md: "flex",
            sm: "flex",
            xs: "none",
          },
          // border: "1px solid red",
          // backgroundImage: `url(${grid})`, // 👈 image path
          // backgroundSize: "contain", // cover entire area
          // backgroundPosition: "center", // center the image
        }}
      >
        <PerformanceMetrics />
      </Stack>

      <Stack
        sx={{
          display: {
            xl: "none",
            lg: "none",
            md: "none",
            sm: "none",
            xs: "flex",
          },
        }}
      >
        <PerformanceMetricsMobile />
      </Stack>
    </Stack>
  );
};

export default MainPerformanceMetrics;
